export default "__VITE_ASSET__CwrG7YzR__"